export enum IntegrationStatus {
    INACTIVE = 'inactive',
    PENDING = 'pending',
    REGISTERED = 'registered',
    ACTIVE = 'active',
}

export enum PaymentGateway {
    STRIPE = 'stripe',
    XENDIT = 'xendit',
}

export interface StudioPaymentIntegration {
    integrationStatus: IntegrationStatus
    externalId?: string
    paymentGateway: PaymentGateway
}
